import * as React from 'react';
import System from 'src/helper/system';

const OrderDetailEmailItemStatusPopup = (props) => {
    const { data, SetStatus } = props
    const { translation: t } = System;

    const onHide = () => {
        SetStatus(false)
    };

    return (
        <>
            <div className="avnet-modal model-710">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => { onHide() }}>×</button>

                    <div className="modal-header border-0">
                        <h3 className="modal-title m-auto" id="exampleModalLabel">{data.isSubmitted ? <b>{t('messageSent')}</b> : <b>{t('emailFailed')}</b>}</h3>
                    </div>
                    <div className="bs5 modal-body text-center">
                        {data.isSubmitted ?
                            <>
                                {t('yourMessageSentSuccessfully')}.
                            </>
                            :
                            <>
                                {t('yourEmailNotSentTryAgain')}
                            </>}

                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <button className="bs5 btn btn-primary"
                            onClick={() => { onHide() }}
                        >{t('close')}</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrderDetailEmailItemStatusPopup;